module.exports = __webpack_public_path__ + "img/PDF.3ad6cd92.svg";